export const CRSStatusOptions = [
  'CancellationRequested',
  'Cancelled',
  'Confirmed',
  'ModificationExpired',
  'ModificationFailed',
  'ModificationRequested',
  'ModificationReserved',
  'ReservationExpired',
  'ReservationFailed',
  'ReservationRequested',
  'Reserved',
  'OptionReserved',
  'OptionReservationFailed',
  'ConfirmationFailed',
  'NoShow',
  'Primitive',
  'PrimitiveExpired'
]
export const PMSStatusOptions = [
  'CancellationFailed',
  'Cancelled',
  'ConfirmationFailed',
  'Confirmed',
  'ModificationConfirmationFailed',
  'ModificationExpirationFailed',
  'ModificationExpired',
  'ModificationFailed',
  'ModificationReserved',
  'PendingCancellation',
  'PendingConfirmation',
  'PendingExpiration',
  'PendingModification',
  'PendingModifyConfirmation',
  'PendingModifyExpiration',
  'PendingReservation',
  'ReservationExpirationFailed',
  'ReservationExpired',
  'ReservationFailed',
  'Reserved',
  'OptionReserved',
  'OptionReservationFailed',
  'NoShow'
]
